module.exports = __webpack_public_path__ + "img/crt_error.f307a4a8.svg";